// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../node_modules/rescript/lib/es6/list.js";
import * as Curry from "../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as TrackLiveTripConfig from "../../domain/store/TrackLiveTripConfig.bs.js";
import * as TrackLiveTripHelper from "../../helper/TrackLiveTripHelper.bs.js";
import * as ExternalLink$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/components/generic/external-link/ExternalLink.bs.js";
import * as ReasonReactUtils$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/utils/ReasonReactUtils.bs.js";
import * as TrackLiveTripAssetsManager from "../assets/TrackLiveTripAssetsManager.bs.js";

var pickup_icon = TrackLiveTripAssetsManager.getTrackLiveTripsImage("pickup_address_icon.svg");

var drop_icon = TrackLiveTripAssetsManager.getTrackLiveTripsImage("drop_address_icon.svg");

var waypoint_img = TrackLiveTripAssetsManager.getTrackLiveTripsImage("waypoint.svg");

var mobile = TrackLiveTripAssetsManager.getTrackLiveTripsImage("mobile_icon.svg");

function getCountryDailingCode(param) {
  return "+91";
}

function getPickupAddress(pickupAddress) {
  return React.createElement("div", {
              className: "track-live-trip-header__detail-address-row"
            }, React.createElement("div", {
                  className: "waypoint-icon waypoint-icon__green"
                }, React.createElement("div", {
                      className: "icon icon__pickup"
                    })), React.createElement("div", {
                  className: "track-live-trip-header__detail-address"
                }, pickupAddress), React.createElement("div", {
                  className: "track-live-trip-header__vertical-line"
                }));
}

function getWaypointInfo(details) {
  return ReasonReactUtils$Catalyst.listToReactArray(List.mapi((function (idx, waypoint) {
                    var tmp;
                    if (idx === (List.length(details.waypointAddresses) - 1 | 0)) {
                      var match = details.isRental;
                      var match$1 = details.dropAddress;
                      tmp = match || match$1 === undefined ? null : React.createElement("div", {
                              className: "track-live-trip-header__vertical-line"
                            });
                    } else {
                      tmp = React.createElement("div", {
                            className: "track-live-trip-header__vertical-line"
                          });
                    }
                    return React.createElement("div", {
                                key: String(idx),
                                className: "track-live-trip-header__detail-address-row"
                              }, React.createElement("div", {
                                    className: "waypoint-icon"
                                  }, React.createElement("div", undefined, String(idx + 1 | 0))), React.createElement("div", {
                                    className: "track-live-trip-header__detail-address"
                                  }, waypoint), tmp);
                  }), details.waypointAddresses));
}

function getDropAddress(details) {
  var match = details.isRental;
  var match$1 = details.dropAddress;
  if (match || match$1 === undefined) {
    return null;
  } else {
    return React.createElement("div", {
                className: "track-live-trip-header__detail-address-row"
              }, React.createElement("div", {
                    className: "waypoint-icon waypoint-icon__red"
                  }, React.createElement("div", {
                        className: "icon"
                      })), React.createElement("div", {
                    className: "track-live-trip-header__detail-address"
                  }, match$1));
  }
}

function getHeaderTitle(title) {
  return React.createElement("div", {
              className: "track-live-trip-header__detail-trip-title"
            }, title);
}

function getCrnDetails(crn) {
  return React.createElement("div", {
              className: "track-live-trip-header__crn-details"
            }, TrackLiveTripConfig.order_id_text + crn);
}

function getHeaderDetailAddressSegment(details) {
  return React.createElement("div", {
              className: "track-live-trip-header__detail-trip-address"
            }, React.createElement("div", {
                  className: "track-live-trip-header__detail-address-block"
                }, getCrnDetails(details.crn), getPickupAddress(details.pickupAddress), getWaypointInfo(details), getDropAddress(details)));
}

function getHeaderDetailTripSegment(details) {
  return React.createElement("div", {
              className: "track-live-trip-header__detail-trip-container"
            }, getHeaderTitle(TrackLiveTripConfig.order_details_text), getHeaderDetailAddressSegment(details));
}

function getCallIcon(details) {
  if (details.customerInfo.mobile !== "") {
    return React.createElement("div", {
                className: "track-live-trip-header__title-action-button",
                onClick: (function (param) {
                    return TrackLiveTripHelper.publishEvent(TrackLiveTripConfig.ga_title_track_live_trip, "Clicked Customer Call Placer", undefined, details.crn, undefined);
                  })
              }, React.createElement(ExternalLink$Catalyst.make, {
                    link: "tel:+91" + details.customerInfo.mobile,
                    className: "track-live-trip-header__title-mobile-link",
                    children: React.createElement("img", {
                          className: "track-live-trip-header__title-mobile-img",
                          src: mobile
                        })
                  }));
  } else {
    return null;
  }
}

function getCustomerDetails(details) {
  return React.createElement("div", {
              className: "track-live-trip-header__detail-trip-container"
            }, React.createElement("div", {
                  className: "track-live-trip-header__sender_info"
                }, React.createElement("div", {
                      className: "track-live-trip-header__details_sender"
                    }, getHeaderTitle(TrackLiveTripConfig.order_placed_by_text), details.customerInfo.name), getCallIcon(details)));
}

function getContactSupport(details) {
  if (details.customerSupportContact !== "") {
    return React.createElement("div", {
                className: "track-live-trip-header__detail-trip-container"
              }, React.createElement("div", {
                    className: "track-live-trip-header__contact-support-section"
                  }, React.createElement("div", undefined, TrackLiveTripConfig.experiencing_issues_text), React.createElement(ExternalLink$Catalyst.make, {
                        link: "tel:+91" + details.customerSupportContact,
                        className: "",
                        children: React.createElement("div", {
                              onClick: (function (param) {
                                  return TrackLiveTripHelper.publishEvent(TrackLiveTripConfig.ga_title_track_live_trip, "Clicked Contact Support", undefined, details.crn, undefined);
                                })
                            }, TrackLiveTripConfig.contact_support_text)
                      })));
  } else {
    return null;
  }
}

function renderContactSupport(details) {
  var match = details.status;
  if (match === 5 || match === 4) {
    return null;
  } else {
    return getContactSupport(details);
  }
}

function hideOrderDetails(onDetailClick) {
  return React.createElement("div", {
              className: "track-live-trip-header__show-order-details-container",
              onClick: (function (_event) {
                  return Curry._1(onDetailClick, undefined);
                })
            }, React.createElement("div", undefined, TrackLiveTripConfig.hide_order_details_text), React.createElement("div", {
                  className: "track-live-trip-header__show-order-details-container__indicator__hide"
                }, React.createElement("img", {
                      src: TrackLiveTripAssetsManager.getTrackLiveTripsImage("drop-down-arrow.svg")
                    })));
}

function TrackLiveTripHeaderDetailComponent(Props) {
  var details = Props.details;
  var onDetailClick = Props.onDetailClick;
  return React.createElement("div", {
              className: "track-live-trip-header__detail-container"
            }, getHeaderDetailTripSegment(details), getCustomerDetails(details), renderContactSupport(details), hideOrderDetails(onDetailClick));
}

var make = TrackLiveTripHeaderDetailComponent;

export {
  pickup_icon ,
  drop_icon ,
  waypoint_img ,
  mobile ,
  getCountryDailingCode ,
  getPickupAddress ,
  getWaypointInfo ,
  getDropAddress ,
  getHeaderTitle ,
  getCrnDetails ,
  getHeaderDetailAddressSegment ,
  getHeaderDetailTripSegment ,
  getCallIcon ,
  getCustomerDetails ,
  getContactSupport ,
  renderContactSupport ,
  hideOrderDetails ,
  make ,
  
}
/* pickup_icon Not a pure module */
